import { Button } from '@mantine/core';
import Link from 'next/link';

export function CategoryButton({ id, name }: { id: string; name: string }) {
  return (
    <Button
      c="gray"
      fw={500}
      variant="subtle"
      size="compact-md"
      component={Link}
      href={`/products?categoryId=${id}`}
    >
      {name}
    </Button>
  );
}
